var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filter-form',_vm._b({key:_vm.objectsType,ref:"filterForm"},'filter-form',_vm.schema,false))}
var staticRenderFns = []

export { render, staticRenderFns }